import {
  Box,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { Fragment } from "react";
import Logo from "../../../components/Logo";
import { makeStyles } from "tss-react/mui";
import { ChevronLeftRounded, MenuRounded } from "@mui/icons-material";

const useStyles = makeStyles()((theme) => ({
  gradientText: {
    background: theme.palette.light,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));

function Header({ expanded, onToggleExpand }) {
  const { classes } = useStyles();
  const theme = useTheme();
  const isXS = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      p={1.5}
      display={"flex"}
      alignItems={"center"}
      justifyContent={expanded ? "start" : "center"}>
      {isXS && <Logo variant="small" />}
      {!isXS && (
        <IconButton
          onClick={() => onToggleExpand(!expanded)}
          sx={{ mr: expanded ? 1 : 0 }}>
          <MenuRounded />
        </IconButton>
      )}
      {expanded && <Logo variant="small" />}
    </Box>
  );
}

export default Header;
